// removed by extract-text-webpack-plugin
module.exports = {"footerTotals":"RleyZYQlL8d-sMFjyYDg2","Collapsible__contentOuter":"_1geZbnkcJ9-STBRUG1AdDY","collapsibleContentOuter":"_1geZbnkcJ9-STBRUG1AdDY"};


//////////////////
// WEBPACK FOOTER
// ./components/product-detail/footer.css
// module id = 940
// module chunks = 0